import React from 'react';
import { Box, Card, CardContent } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { DOCUMENTS_GRID_SKELETON_COUNT } from './constants';
import { useDocumentsGridSkeletonStyles } from './documentsGridStyles';

export const DocumentsGridSkeleton = () => {
    const classes = useDocumentsGridSkeletonStyles();

    return (
        <Box className={classes.container}>
            {Array.from({ length: DOCUMENTS_GRID_SKELETON_COUNT }).map((_, index) => (
                <Box key={index} className={classes.itemWrapper}>
                    <Card className={classes.card} elevation={0}>
                        <Skeleton
                            variant="rect"
                            className={classes.imageSkeleton}
                            animation="wave"
                        />
                        <CardContent className={classes.content}>
                            <Skeleton variant="text" width="80%" animation="wave" />
                            <Skeleton variant="text" width="60%" animation="wave" />
                            <Skeleton variant="text" width="40%" animation="wave" />
                        </CardContent>
                    </Card>
                </Box>
            ))}
        </Box>
    );
};
